import React, { FC, useState } from 'react';
import { Typography, Grid } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { NumberInput, maxValue, minValue, number, required } from 'react-admin';

import { ShsCheckbox } from '../../common';
import { CheckboxStyles, NumberInputStyles } from '../common/styles';
import { SUBJECT_TYPE } from 'src/constants';

export const SubjectPlanningCreateControl: FC<{ sourceName: string; label: string }> = ({ sourceName, label }) => {
    const [readonly, setReadonly] = useState(true);
    const form = useFormContext();
    const fieldName = `planning.${sourceName}`;

    const inputValidators = [number('1-999'), minValue(1, '1-999'), maxValue(999, '1-999')];
    const isPsychologySubjectType = form.watch().subject_type === SUBJECT_TYPE.PSYCHOLOGY;

    if (!readonly && !isPsychologySubjectType) {
        inputValidators.push(required('Поле є обов`язковим'));
    }

    const handleCheckboxChange = () => {
        if (!readonly) {
            form.resetField(fieldName);
        }

        setReadonly(!readonly);
    };

    return (
        <>
            <Grid item md={3} sm={4} xs={4}>
                <ShsCheckbox
                    value={!readonly}
                    source=""
                    label={label}
                    onChange={handleCheckboxChange}
                    sx={CheckboxStyles}
                />
            </Grid>
            <Grid item md={4} sm={4} xs={6}>
                <Typography noWrap>Кількість годин/тиждень</Typography>
            </Grid>
            <Grid item md={5} sm={4} xs={2}>
                <NumberInput
                    source={fieldName}
                    label={false}
                    readOnly={readonly}
                    helperText={false}
                    validate={inputValidators}
                    sx={NumberInputStyles}
                />
            </Grid>
        </>
    );
};
